import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface User {
  id: number;
  username: string;
  email: string;
  estado: number;
  tenant_id: number;
  two_factor_enabled: boolean;
  created_at: string;
  updated_at: string;
  empresa_id: number;
  roles: { id: number; nombre: string }[];
}

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private apiUrl = `${environment.apiUrl}/api/users`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<User[]> {
    return this.http.get<User[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener usuarios:', error);
        return throwError(() => error);
      })
    );
  }

  getById(id: number): Observable<User> {
    return this.http.get<User>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  update(id: number, data: Partial<User> & { rol?: number; password?: string }): Observable<User> {
    return this.http.put<User>(`${this.apiUrl}/${id}`, data, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  inactivarUser(id: number): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getPermisosByUsuario(userId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${userId}/permisos`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  updatePermisos(userId: number, permisoIds: number[]): Observable<any> {
    return this.http.put(`${this.apiUrl}/${userId}/permisos`, { permisos: permisoIds }, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  create(data: { username: string; email: string; password: string; rol?: number; estado?: number; tenant_id?: number; empresa_id?: number }): Observable<User> {
    return this.http.post<User>(`${this.apiUrl}/register`, data, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getVehiculosByUsuario(userId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${userId}/vehiculos`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  updateVehiculos(userId: number, placas: string[]): Observable<any> {
    return this.http.put(`${this.apiUrl}/${userId}/vehiculos`, { vehiculos: placas }, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  impersonar(userId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${userId}/impersonate`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }
}
